import { render, staticRenderFns } from "./SDAProductList.vue?vue&type=template&id=1fc87ec0"
import script from "./SDAProductList.vue?vue&type=script&lang=js"
export * from "./SDAProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports